import React, { Component } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import CurrencyValue from './currencyValue';
import ChangeValue from './changeValue';
import Cookies from 'universal-cookie';

// Sürükle-bırak ile sıralanabilen tablo satırı / gövdesi.
const SortableFavRow = SortableElement(({ rowClass, children }) => (
  <tr className={rowClass}>{children}</tr>
));
const SortableFavBody = SortableContainer(({ children }) => <tbody>{children}</tbody>);

const MAX_FAVORITES = 15;
const COOKIE = 'FavoriesAll';
// Varsayılan favoriler (kod bazlı; veri geldiğinde anahtara çözülür).
const DEFAULT_DOVIZ = ['USD', 'EUR', 'CHF'];
const DEFAULT_ALTIN = ['HAS', 'GA'];

// Alt gruplar — sitedeki panellerle aynı başlıklar.
// Gold (avalues) DataGroup'ları:
const GOLD_SUBS = {
  2:  { order: 1, title: 'Altın' },
  10: { order: 2, title: 'Gram Altın' },
  8:  { order: 5, title: 'Yeni Sarrafiye' },
  9:  { order: 6, title: 'Eski Sarrafiye' },
  5:  { order: 7, title: 'Sarrafiye İşçilik' },
  6:  { order: 8, title: 'Gram Altın İşçilik' },
  7:  { order: 9, title: 'Gümüş' }
};
// Currency (dvalues) DataGroup'ları:
const CURR_SUBS = {
  1:  { order: 1, title: 'Döviz' },
  4:  { order: 2, title: 'Parite' },
  3:  { order: 3, title: 'KG Altın' },
  10: { order: 4, title: 'Ons' }
};

class FavoriKur extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ids: [],              // seçili favori anahtarları (_key)
      values: [],           // gösterilecek canlı satırlar
      showSettings: false,
      atLimit: false,
      search: '',
      openGroups: { doviz: true, altin: true }  // mobilde akordeon
    };
    this.initialized = false;
  }

  isMobile() {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  componentDidMount() {
    this.tryInit();
  }

  componentDidUpdate(prevProps) {
    if (this.props.avalues !== prevProps.avalues || this.props.dvalues !== prevProps.dvalues) {
      this.tryInit();
      this.rebuildValues(this.state.ids);
    }
  }

  // Tüm kaynağı (döviz + altın) grup etiketli olarak üret.
  buildAll() {
    const golds = Array.isArray(this.props.avalues) ? this.props.avalues : [];
    const curr = Array.isArray(this.props.dvalues) ? this.props.dvalues : [];
    const out = [];

    golds.forEach(it => {
      if (it && it.Id !== undefined && it.Id !== null) {
        const sub = GOLD_SUBS[Number(it.DataGroup)] || { order: 99, title: 'Diğer' };
        out.push(Object.assign({}, it, {
          _key: 'g' + it.Id,
          _group: 'altin',
          _subOrder: sub.order,
          _subTitle: sub.title,
          _label: (it.MobilAciklama || it.Aciklama || it.Kod || '').trim()
        }));
      }
    });

    curr.forEach(it => {
      if (it && it.Id !== undefined && it.Id !== null) {
        const dg = Number(it.DataGroup);
        const sub = CURR_SUBS[dg];
        if ([1, 4].includes(dg)) {
          out.push(Object.assign({}, it, {
            _key: 'c' + it.Id,
            _group: 'doviz',
            _subOrder: sub.order,
            _subTitle: sub.title,
            _label: (it.Kod || it.MobilAciklama || '').trim()
          }));
        } else if ([10, 3].includes(dg)) {
          out.push(Object.assign({}, it, {
            _key: 'c' + it.Id,
            _group: 'altin',
            _subOrder: sub.order,
            _subTitle: sub.title,
            _label: (it.MobilAciklama || it.Aciklama || it.Kod || '').trim()
          }));
        }
      }
    });

    return out;
  }

  isActive(item) {
    const v = item && item.IsActive;
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v !== 0;
    if (typeof v === 'string') return v.toLowerCase() === 'true' || v === '1';
    return true;
  }

  // Seçici listesi (gruba göre, aktif, anahtara göre tekilleştirilmiş).
  // Sıra: önce DataGroup, aynı grup içinde Id (order alanı yok, Id sıralamayı verir).
  pickerItems(group) {
    const seen = {};
    return this.buildAll()
      .filter(it => it._group === group && this.isActive(it) && it._label)
      .filter(it => { if (seen[it._key]) return false; seen[it._key] = true; return true; })
      .sort((a, b) =>
        (a._subOrder - b._subOrder) ||
        (Number(a.Id) - Number(b.Id))
      );
  }

  // Alt gruplara (panellerdeki başlıklara) böl.
  subGroupsOf(items) {
    const map = [];
    items.forEach(it => {
      let bucket = map.find(m => m.order === it._subOrder);
      if (!bucket) { bucket = { order: it._subOrder, title: it._subTitle, items: [] }; map.push(bucket); }
      bucket.items.push(it);
    });
    return map.sort((a, b) => a.order - b.order);
  }

  // Veri geldiğinde bir kez favori seçimini (cookie/varsayılan) uygula.
  tryInit() {
    if (this.initialized) return;
    const all = this.buildAll();
    if (all.length === 0) return; // veri henüz yok

    this.initialized = true;
    const cookies = new Cookies();
    let ids = cookies.get(COOKIE);

    if (!Array.isArray(ids)) {
      // Varsayılanları kod üzerinden anahtara çöz.
      ids = [];
      const byKod = (group, kod) => {
        const f = all.find(it => it._group === group && (it.Kod || '').toUpperCase() === kod.toUpperCase());
        return f ? f._key : null;
      };
      DEFAULT_DOVIZ.forEach(k => { const key = byKod('doviz', k); if (key) ids.push(key); });
      DEFAULT_ALTIN.forEach(k => { const key = byKod('altin', k); if (key) ids.push(key); });
      // Hiç eşleşmediyse her gruptan ilk ikişer öğe.
      if (ids.length === 0) {
        ids = this.pickerItems('doviz').slice(0, 2).map(it => it._key)
          .concat(this.pickerItems('altin').slice(0, 2).map(it => it._key));
      }
      cookies.set(COOKIE, ids, { path: '/', maxAge: 315360000 });
    }

    this.setState({ ids, atLimit: ids.length >= MAX_FAVORITES }, () => this.rebuildValues(ids));
  }

  rebuildValues(ids) {
    const all = this.buildAll();
    const map = {};
    all.forEach(it => { map[it._key] = it; });
    const values = ids.map(id => map[id]).filter(Boolean);
    this.setState({ values });
  }

  toggle = (key) => {
    let ids = this.state.ids.slice();
    const idx = ids.indexOf(key);
    if (idx !== -1) {
      ids.splice(idx, 1);
    } else {
      if (ids.length >= MAX_FAVORITES) return; // limit
      ids.push(key);
    }
    const cookies = new Cookies();
    cookies.set(COOKIE, ids, { path: '/', maxAge: 315360000 });
    this.setState({ ids, atLimit: ids.length >= MAX_FAVORITES }, () => this.rebuildValues(ids));
  }

  toggleSettings = () => {
    this.setState(state => {
      const showSettings = !state.showSettings;
      // Panel açılırken: mobilde gruplar kapalı, masaüstünde açık başlasın.
      const open = !(showSettings && this.isMobile());
      return { showSettings, openGroups: { doviz: open, altin: open } };
    });
  }

  // Sürüklenen satırın kopyası tablo dışına taşındığı için hücre
  // genişlikleri çöküyor; orijinal genişlikleri kopyaya uygula.
  onSortStart = ({ node, helper }) => {
    const src = node.children;
    Array.prototype.forEach.call(helper.children, (cell, i) => {
      if (src[i]) cell.style.width = src[i].offsetWidth + 'px';
    });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return;
    const ids = arrayMove(this.state.ids, oldIndex, newIndex);
    const cookies = new Cookies();
    cookies.set(COOKIE, ids, { path: '/', maxAge: 315360000 });
    this.setState({ ids }, () => this.rebuildValues(ids));
  }

  toggleGroup = (group) => {
    this.setState(state => ({
      openGroups: Object.assign({}, state.openGroups, { [group]: !state.openGroups[group] })
    }));
  }

  onSearch = (e) => {
    this.setState({ search: e.target.value });
  }

  showCode = tag => {
    // Ayarlar açıkken sürüklenebilirliği belli eden 3 çizgi ikonu.
    const grip = this.state.showSettings
      ? <i className="zmdi zmdi-menu fav-grip"></i>
      : null;

    if (tag._group === 'doviz') {
      return <td>{grip}{tag['Kod']}</td>;
    }
    var aciklama = tag['Aciklama'] ? <span>{tag['Aciklama']}</span> : '';
    return <td>{grip}{(tag['MobilAciklama'] || '').trim()} {aciklama}</td>;
  }

  renderGroup(title, group) {
    const q = this.state.search.trim().toLocaleLowerCase('tr');
    const items = this.pickerItems(group).filter(it => {
      if (!q) return true;
      return (it._label + ' ' + (it.Kod || '')).toLocaleLowerCase('tr').indexOf(q) !== -1;
    });
    if (items.length === 0) return null;

    const open = this.state.openGroups[group];
    return <div className={"fav-group fav-group-" + group + (open ? " open" : " closed")} key={group}>
      <div className="fav-group-title" onClick={() => this.toggleGroup(group)}>
        <span>{title}</span>
        <i className="zmdi zmdi-chevron-down fav-group-caret"></i>
      </div>
      <div className="fav-subgroups">
        {this.subGroupsOf(items).map(sub => (
          <div className="fav-subgroup" key={sub.order}>
            {/* Üst grup adıyla aynı olan alt başlığı tekrar gösterme. */}
            {sub.title !== title && <div className="fav-subtitle">{sub.title}</div>}
            <div className="fav-options">
              {sub.items.map(it => {
                const checked = this.state.ids.indexOf(it._key) !== -1;
                const disabled = !checked && this.state.atLimit;
                return <label className={"fav-option" + (disabled ? " disabled" : "")} key={it._key}>
                  <input type="checkbox" checked={checked} disabled={disabled} onChange={() => this.toggle(it._key)} />
                  <span>{it._label}</span>
                </label>;
              })}
            </div>
          </div>
        ))}
      </div>
    </div>;
  }

  render() {
    return <div id="fav-all" className="card gold-head">
      <div className="card-header fav-settings" style={{ display: this.state.showSettings ? 'block' : 'none' }}>
        <div className="fav-picker">
          <div className="fav-picker-head">
            <span>En fazla {MAX_FAVORITES} favori ekleyebilirsiniz.{this.state.atLimit ? ' (Limit doldu)' : ''}</span>
            <input
              type="text"
              className="fav-search"
              placeholder="Kur ara..."
              value={this.state.search}
              onChange={this.onSearch}
            />
          </div>
          <div className="fav-picker-body">
            {this.renderGroup('Döviz', 'doviz')}
            {this.renderGroup('Altın', 'altin')}
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-box">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Favorilerim</th>
                  <th scope="col">Alış</th>
                  <th scope="col">Satış</th>
                  <th scope="col" className="fav-gear" onClick={this.toggleSettings}>
                    <i className="zmdi zmdi-settings zmdi-hc-lg"></i>
                  </th>
                </tr>
              </thead>
              <SortableFavBody
                onSortStart={this.onSortStart}
                onSortEnd={this.onSortEnd}
                lockAxis="y"
                pressDelay={180}
                helperClass="fav-dragging"
              >
                {this.state.values.map((tag, index) => (
                  <SortableFavRow
                    key={tag['_key']}
                    index={index}
                    rowClass={tag['_group'] === 'doviz' ? 'fav-doviz' : 'fav-altin'}
                  >
                    {this.showCode(tag)}
                    <CurrencyValue id={'fav' + tag['_key']} value={tag['Alis']} />
                    <CurrencyValue id={'favs' + tag['_key']} value={tag['Satis']} />
                    <ChangeValue value={tag['Change']} />
                  </SortableFavRow>
                ))}
              </SortableFavBody>
            </table>
          </div>
        </div>
      </div>
    </div>;
  }
}

export default FavoriKur;
